"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Input =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Input, _PureComponent);

  function Input() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Input)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var onChange = _this.props.onChange;

      if ((0, _spauiUtils.isFunction)(onChange) && event && event.target) {
        onChange(event, event.target.value || '');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      var _this$props = _this.props,
          value = _this$props.value,
          onKeyPress = _this$props.onKeyPress,
          _this$props$inputProp = _this$props.inputProps,
          inputProps = _this$props$inputProp === void 0 ? {} : _this$props$inputProp;

      if (inputProps && (0, _spauiUtils.isFunction)(inputProps.onKeyPress)) {
        inputProps.onKeyPress(event);
      }

      if ((0, _spauiUtils.isFunction)(onKeyPress)) {
        onKeyPress(event, value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickSearchIcon", function (event) {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onClickSearchIcon = _this$props2.onClickSearchIcon;

      if ((0, _spauiUtils.isFunction)(onClickSearchIcon)) {
        onClickSearchIcon(event, value);
      }
    });

    return _this;
  }

  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          name = _this$props3.name,
          value = _this$props3.value,
          placeholder = _this$props3.placeholder,
          disabled = _this$props3.disabled,
          _this$props3$MoreDeta = _this$props3.MoreDetailComponent,
          MoreDetailComponent = _this$props3$MoreDeta === void 0 ? null : _this$props3$MoreDeta,
          htmlRef = _this$props3.htmlRef,
          onClear = _this$props3.onClear,
          clear = _this$props3.clear,
          onClick = _this$props3.onClick,
          _this$props3$classNam = _this$props3.classNameMap,
          classNameMap = _this$props3$classNam === void 0 ? {} : _this$props3$classNam,
          inputProps = _this$props3.inputProps;
      var moreDetailComponentInstance = null;

      if ((0, _spauiUtils.isFunction)(MoreDetailComponent)) {
        moreDetailComponentInstance = _react["default"].createElement(MoreDetailComponent, {
          name: name,
          placeholder: placeholder,
          value: value,
          disabled: disabled,
          clear: clear,
          onClear: onClear
        });
      } else {
        moreDetailComponentInstance = MoreDetailComponent;
      }

      return _react["default"].createElement("div", {
        className: classNameMap.AutoCompleteHeadClassName,
        onClick: onClick
      }, _react["default"].createElement(_spauiIcon["default"], {
        type: "viewer",
        onClick: this.handleClickSearchIcon
      }), _react["default"].createElement("input", _extends({}, inputProps, {
        className: "spaui-input",
        name: name,
        value: value,
        placeholder: placeholder,
        disabled: disabled,
        onChange: this.handleChange,
        onKeyPress: this.handleKeyPress,
        ref: htmlRef
      })), value && !disabled && clear ? _react["default"].createElement("div", {
        className: "spaui-input-clear",
        role: "button",
        onClick: onClear
      }, _react["default"].createElement("svg", {
        viewBox: "0 0 16 16",
        width: "16px",
        height: "16px"
      }, _react["default"].createElement("circle", {
        fill: "currentColor",
        fillRule: "evenodd",
        cx: "8",
        cy: "8",
        r: "8"
      }), _react["default"].createElement("path", {
        d: "M5.333 5.333l5.334 5.334M10.667 5.333l-5.334 5.334",
        stroke: "#FFF",
        strokeLinecap: "square"
      }))) : null, _react["default"].createElement("span", {
        className: classNameMap.AutoCompleteMoreDetailClassName
      }, moreDetailComponentInstance));
    }
  }]);

  return Input;
}(_react.PureComponent);

var _default = Input;
exports["default"] = _default;